import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProjetcsService} from '../../../projetcs.service';
import { GlobalService} from '../../../../shared/services/global.service';
import { FilterService} from '../../../../shared/services/filter.service';

@Component({
    selector: 'app-add-scene-comment',
    templateUrl: './add-scene-comment.component.html',
    styleUrls: ['./add-scene-comment.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddSceneCommentComponent implements OnInit {
	@Input() sceneId:string;
	@Input() comment:any;
	@Output() closeView  = new EventEmitter<string>();
	@Output() notify  = new EventEmitter<string>();
	loading:boolean = false;

	submitForm(){
		this.loading = true;
		this._pS.addSceneComment(this.sceneId, this.comment.id, this.comment.comment)
	  		.subscribe(
				data => {
					this.notify.emit();
				}
			)
	}
	close(){
		event.stopPropagation();
		this.closeView.emit()
	}

  constructor(private _pS:ProjetcsService, public _gS:GlobalService, private _fS:FilterService, private datePipe:DatePipe) { }

  ngOnInit() {
  	if (!this.comment) {
  		this.comment = {
  			id:'',
  			comment:''	
  		}
  	}
  }

}
